module.exports = __webpack_public_path__ + "img/buy.e6745a8a.svg";